import React from 'react';
import { Popper } from '../../../../third-party-components/material-ui';
import { FormControl, FormLabel, TextField } from '../../../../third-party-components/material-ui';

const Test = (props) => {
    return (
        <div>hi</div>
    )
}
const DemoQuestiontext = ({name, label = '', className = '', required = false, visible = true, value = '', onChange, validationMessage = '', inputProps = {}, helperText = '', type = '', multiline = false }) => {
    return (
        <div style={{display: visible ? 'block' : 'none'}}>
            <FormControl className={`demo-control demo-text ${className}`} component="fieldset">
                <FormLabel className="demo-label" component="legend">{label}{required && <span className="label-required">*</span>}</FormLabel>
                <FormLabel className={"demo-error" + (validationMessage != '' ? ' margin' : '')} component="legend">{validationMessage}</FormLabel>
                <TextField
                    name={name}
                    autoComplete="off"
                    value={value}
                    valid={validationMessage && validationMessage.length > 0 ? validationMessage : ''}
                    variant="outlined"
                    onChange={onChange}
                    inputProps={inputProps}
                    helperText={helperText}
                    type={type}
                    multiline={multiline}
                    style={{background: 'white', width: '100%'}}
                />
            </FormControl>
        </div>
    )
}

export default DemoQuestiontext;